import { render, staticRenderFns } from "./Form1.vue?vue&type=template&id=53dda422"
import script from "./Form1.vue?vue&type=script&lang=js"
export * from "./Form1.vue?vue&type=script&lang=js"
import style0 from "./Form1.vue?vue&type=style&index=0&id=53dda422&prod&lang=scss"
import style1 from "./Form1.vue?vue&type=style&index=1&id=53dda422&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports